"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.settings = void 0;
var dayjs_1 = __importDefault(require("../dayjs"));
var Settings = /** @class */ (function () {
    function Settings() {
        // 'en' - preloaded locale in dayjs
        this.loadedLocales = new Set(['en']);
        this.updateLocale({ weekStart: 1 });
    }
    Settings.prototype.loadLocale = function (locale) {
        return __awaiter(this, void 0, void 0, function () {
            var localeInLowerCase, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.isLocaleLoaded(locale)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        localeInLowerCase = locale.toLocaleLowerCase();
                        // https://github.com/iamkun/dayjs/issues/792#issuecomment-639961997
                        return [4 /*yield*/, require("dayjs/locale/".concat(localeInLowerCase, ".js"))];
                    case 2:
                        // https://github.com/iamkun/dayjs/issues/792#issuecomment-639961997
                        _a.sent();
                        this.loadedLocales.add(localeInLowerCase);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        throw new Error("Can't load locale \"".concat(locale, "\". Either it does not exist, or there was a connection problem. Check the dayjs locations list: https://github.com/iamkun/dayjs/tree/dev/src/locale"));
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Settings.prototype.getLocale = function () {
        return dayjs_1.default.locale();
    };
    Settings.prototype.setLocale = function (locale) {
        if (!this.isLocaleLoaded(locale)) {
            throw new Error("Seems you are trying to set an unloaded locale \"".concat(locale, "\". Load it first by calling settings.loadLocale('").concat(locale, "'). Check the dayjs locations list: https://github.com/iamkun/dayjs/tree/dev/src/locale"));
        }
        dayjs_1.default.locale(locale);
    };
    Settings.prototype.updateLocale = function (config) {
        var locale = this.getLocale();
        dayjs_1.default.updateLocale(locale, config);
    };
    Settings.prototype.isLocaleLoaded = function (locale) {
        var localeInLowerCase = locale.toLocaleLowerCase();
        return this.loadedLocales.has(localeInLowerCase);
    };
    return Settings;
}());
/**
 * Settings to manage Dayjs customization
 */
exports.settings = new Settings();
